<template>
  <shared-provide-variation :variation="variation" :fromModule="fromModule" :toModule="toModule" @change="emitToParent" :disabledInputList="variation.match ? disabledInputList : []">

    <div class="divider"><span>Atributos</span></div>

    <div class="l-row">
      <form-group :label="$t(`manufacturerReference.label`)" :columns="3" :error="getError('manufacturerReference', variation.sku)" :required="true">
        <input class="form-input" type="text" v-model="variation.manufacturerReference" :disabled="disabledInputs()">
      </form-group>

      <form-group :label="$t(`crossDocking.label`)" :columns="3" :error="getError('crossDocking', variation.sku)">
        <input class="form-input" type="text" v-model="variation.crossDocking" :disabled="disabledInputs()">
      </form-group>

      <form-group v-if="variation.colors" :label="$t(`colorMap.label`)" :columns="3" :error="getError('attributes.colorMap', variation.sku)" :required="true">
        <multiselect v-model="colorMap" :options="variation.colors" track-by="code" label="label" selectLabel="Clique" selectedLabel="Selecionado" placeholder="Selecione a opção" :disabled="disabledInputs()">
        </multiselect>
      </form-group>

      <form-group v-if="variation.attributes.hasOwnProperty('color')" :label="$t(`color.label`)" :columns="3" :error="getError('attributes.color', variation.sku)">
        <input class="form-input" type="text" v-model="variation.attributes.color" :disabled="disabledInputs()">
      </form-group>

      <form-group v-if="variation.sizes" :label="$t(`sizeMap.label`)" :columns="3" :error="getError('attributes.sizeMap', variation.sku)" :required="true">
        <multiselect v-model="sizeMap" :options="variation.sizes" track-by="code" label="label" selectLabel="Clique" selectedLabel="Selecionado" placeholder="Selecione a opção" :disabled="disabledInputs()">
        </multiselect>
      </form-group>

      <form-group v-if="variation.attributes.hasOwnProperty('size')" :label="$t(`size.label`)" :columns="3" :error="getError('attributes.size', variation.sku)">
        <input class="form-input" type="text" v-model="variation.attributes.size" :disabled="disabledInputs()">
      </form-group>

      <form-group :required="true" :label="$t('gender.label')" :columns="3" :error="getError('gender', variation.sku)">
        <select v-model="variation.gender" class="form-select" :disabled="disabledInputs()">
          <option :value="null">{{ $t('choose.label') }}</option>
          <option value="unisex">{{ $t('gender.unisex.label') }}</option>
          <option value="female">{{ $t('gender.female.label') }}</option>
          <option value="male">{{ $t('gender.male.label') }}</option>
        </select>
      </form-group>

      <form-group :required="attribute.required" v-for="(attribute, index) in variation.amazonAttributes"
                  :key="attribute.id" :label="attribute.label" :columns="3"
                  :error="getError(`attributes.${attribute.id}`, variation.sku)">
        <div class="form-flex">
          <select v-model="attribute.value" class="form-select" :disabled="disabledInputs()"
                  v-if="attribute.hasOwnProperty('values') && attribute.values.length">
            <option value="undefined">{{ $t('choose.label') }}</option>
            <option v-for="option in attribute.values" :value="option">{{ option }}</option>
          </select>
          <input class="form-input" type="datetime-local" v-model="attribute.value" :disabled="disabledInputs()" v-else-if="attribute.type === 'dateTime'">
          <input class="form-input" type="text" v-model="attribute.value" :disabled="disabledInputs()" v-else>
          <span class="form-addon" v-if="attribute.unitMeasure !== null">{{ attribute.unitMeasure }}</span>
        </div>
      </form-group>
    </div>
  </shared-provide-variation>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
  import FormGroup from '@/components/template/FormGroup'
  import Loader from '@/components/template/Loader'

  export default {
    data: () => ({
      disabledInputList: [
        'ean',
        'weight',
        'height',
        'width',
        'length'
      ],
      sizeMap: null,
      colorMap: null
    }),
    props: {
      variation: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    async mounted () {
      this.colorMap = this.variation.attributes.colorMap
      this.sizeMap = this.variation.attributes.sizeMap

      this.presetColorMap()
      this.presetSizeMap()

      if (this.variation.gender === '' || this.variation.gender === undefined || this.variation.gender === null) {
        this.variation.gender = 'unisex'
      }
    },
    methods: {
      disabledInputs () {
        return this.variation.status === 'sent' || this.variation.status === 'error' || this.variation.match
      },
      emitToParent (value) {
        this.$emit('change', value)
      },
      presetColorMap () {
        if (
          !this.variation ||
          !this.variation.attributes ||
          !this.variation.colors ||
          !this.variation.colors.length
        ) {
          return
        }

        var hasColor = !!(this.variation.attributes.color && this.variation.attributes.color.toString().trim())
        var colorText = (hasColor ? this.variation.attributes.color.toString().trim() : 'Única').toLowerCase()

        for (var i = 0; i < this.variation.colors.length; i++) {
          var label = this.variation.colors[i].label

          if (
            label &&
            label.toString().toLowerCase().includes(colorText)
          ) {
            this.colorMap = {
              value: this.variation.colors[i].value,
              label: this.variation.colors[i].label
            }
            return
          }
        }

        if (hasColor) {
          this.colorMap = null
        }
      },
      presetSizeMap () {
        if (
          !this.variation ||
          !this.variation.attributes ||
          !this.variation.sizes ||
          !this.variation.sizes.length
        ) {
          return
        }

        var hasSize = !!(this.variation.attributes.size && this.variation.attributes.size.toString().trim())
        var sizeText = hasSize ? this.variation.attributes.size.toString().trim() : 'Único'
        var normalized

        if (sizeText.indexOf('/') !== -1 || sizeText.indexOf('-') !== -1) {
          normalized = sizeText.split('/')[0].split('-')[0].trim() + '.5'
        } else {
          normalized = sizeText
        }

        for (var i = 0; i < this.variation.sizes.length; i++) {
          if (this.variation.sizes[i].label === sizeText || this.variation.sizes[i].label === normalized) {
            this.sizeMap = {
              value: this.variation.sizes[i].value,
              label: this.variation.sizes[i].label
            }
            return
          }
        }

        if (hasSize) {
          this.sizeMap = null
        }
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    watch: {
      colorMap (value) {
        if (value === undefined) {
          this.variation.attributes.colorMap = null
          return
        }

        this.variation.attributes.colorMap = value
      },
      sizeMap (value) {
        if (value === undefined) {
          this.variation.attributes.sizeMap = null
          return
        }

        this.variation.attributes.sizeMap = value
      },
      'variation.colors': {
        handler () {
          this.presetColorMap()
        },
        deep: true
      },
      'variation.sizes': {
        handler () {
          this.presetSizeMap()
        },
        deep: true
      }
    },
    components: {
      SharedProvideVariation,
      FormGroup,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Variation.vue?587fc194